import React from "react";
import _ from "lodash";
import { FormattedMessage } from "react-intl";

import IColumn from "models/IColumn";
import { PictureAsPdf } from "components/Icons";
import { downloadDocument } from "helpers/download";
import { getFormatted } from "helpers/formatting";
import { markAsRead } from "../app/actions";

export const columns: IColumn[] = [
  {
    key: "checkbox",
    isSortable: false,
    fixedWidth: 48,
    visible: true,
    notRowClick: true
  },
  {
    key: "pdf",
    isSortable: false,
    render: rowData => (
      <PictureAsPdf
        id={`download-invoices-${rowData.DocumentId}.pdf`}
        onClick={e => {
          e.stopPropagation();
          downloadDocument(
            rowData,
            () =>
              !_.get(rowData, "Read", true) &&
              markAsRead([rowData.Id], "Factuur")
          );
        }}
      />
    ),
    fixedWidth: 52,
    visible: true,
    notRowClick: true
  },
  {
    title: "INVOICES_NUMBER",
    key: "Number",
    fixedWidth: 128,
    visible: true
  },
  {
    title: "ORDERS_NUMBER",
    key: "Order.Number",
    visible: true
  },
  {
    title: "PURCHASE_TYPE",
    key: "PurchaseType",
    visible: true
  },
  {
    title: "INVOICES_DATE",
    key: "InvoiceDate",
    type: "date",
    visible: true
  },
  {
    title: "PAYMENT_DATE",
    key: "PaymentDate",
    type: "date",
    visible: true
  },
  {
    title: "COUNTERPARTY_NAME",
    key: "CounterParty.Name",
    visible: true
  },
  {
    title: "COUNTERPARTY_NR",
    key: "CounterParty.Number",
    visible: true
  },
  {
    title: "INVOICES_KIND",
    key: "InvoiceTypePortal",
    visible: true
  },
  {
    title: "INVOICES_AMOUNT",
    key: "InvoiceAmountIncVat",
    type: "currency",
    render: rowData =>
      _.includes(["Aankoop", "Purchase", "Buying"], rowData.PurchaseType)
        ? getFormatted(_.get(rowData, "InvoiceAmountIncVat"), "currency")
        : getFormatted(_.get(rowData, "InvoiceAmountIncVat") * -1, "currency"),
    visible: true
  },
  {
    title: "STATUS",
    key: "RemainingAmount",
    render: ({ RemainingAmount }) => (
      <FormattedMessage id={RemainingAmount === 0 ? "CLOSED" : "OPEN"} />
    ),
    visible: true
  }
];
